import { generatePaymentMutationPayload, isPaymentMethodErrorCode } from '../../../helpers';
import { paymentsUrl } from '../../../hooks/syf-api/api';
import { getAuthHeaders, getFormattedPayloadFromVariablesACH, getTrackingHeaders } from '../../../hooks/syf-api/payments';
// eslint-disable-next-line max-lines-per-function
export const handleMultiPaymentMutation = async (apiConfig, multiPaymentFormValues, paymentMethods) => {
    const { paymentAmount, paymentDate, paymentMethod: paymentMethodFromForm } = multiPaymentFormValues;
    const paymentScheduledDate = new Date(paymentDate);
    const paymentMethod = paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.find((method) => {
        return `${method === null || method === void 0 ? void 0 : method.id}` === paymentMethodFromForm;
    });
    const mutationVariables = generatePaymentMutationPayload(paymentScheduledDate, paymentAmount, paymentMethod, true);
    const { amount, date, paymentMedium, settlementFlag } = mutationVariables;
    const { accountId, accountIdType } = apiConfig.keyProps;
    const requestBody = Object.assign({ accountIdType,
        amount, 'cipher.accountId': accountId, date,
        paymentMedium,
        settlementFlag }, (paymentMedium === 'E_CHECK'
        ? {
            paymentMethod: getFormattedPayloadFromVariablesACH(mutationVariables)
        }
        : {}));
    const fullUrl = new URL(paymentsUrl, apiConfig.config.hosts.apigee);
    const response = await fetch(fullUrl.toString(), {
        mode: 'cors',
        headers: Object.assign(Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, getAuthHeaders()), getTrackingHeaders()),
        method: 'POST',
        body: JSON.stringify(requestBody)
    });
    const status = response === null || response === void 0 ? void 0 : response.status;
    let body = null;
    try {
        body = await (response === null || response === void 0 ? void 0 : response.json());
    }
    catch (_a) {
        // noop
    }
    if (!response.ok) {
        const error = new Error();
        error.body = body;
        error.status = status;
        throw error;
    }
    return {
        body,
        status
    };
};
export const sendResultToMultiPaymentFlow = ({ paymentBody, paymentStatus }) => {
    var _a;
    const isPaymentSuccessful = paymentStatus >= 200 && paymentStatus < 300;
    const hasPaymentMethodError = (_a = paymentBody === null || paymentBody === void 0 ? void 0 : paymentBody.businessErrors) === null || _a === void 0 ? void 0 : _a.some(({ code }) => isPaymentMethodErrorCode(code));
    const isPaymentPending = paymentStatus === 202;
    const hasPaymentError = !isPaymentSuccessful;
    return {
        hasPaymentError,
        hasPaymentMethodError,
        isPaymentPending,
        paymentId: paymentBody === null || paymentBody === void 0 ? void 0 : paymentBody.paymentId
    };
};
